import { gql } from '@apollo/client'

export const AGREE_WITH_TERMS_AND_PRIVACY_POLICY = gql`
  mutation agreeWithTermsAndPrivacyPolicy {
    agreeWithTermsAndPrivacyPolicy {
      user {
        id
        hasAgreedToLatestTermsAndPrivacyPolicy
      }
      errors {
        message
        code
      }
    }
  }
`
